import auth from "@/pages/auth/i18n/tr";
import dashboard from "@/pages/dashboard/i18n/tr";
import time from "@/pages/time/i18n/tr";
import leave from "@/pages/leave/i18n/tr";
import hr from "@/pages/hr/i18n/tr";
import feedback from "@/pages/pending-feedbacks/i18n/tr";

export default {
  ...auth,
  ...dashboard,
  ...time,
  ...leave,
  ...hr,
  ...feedback,
  menu: {
    dashboard: "Anasayfa",
    time: "Zaman",
    hr: "İnsan Kaynakları",
    leave: "İzin",
    clock_in_out: "Giriş / Çıkış"
  },
  message: {
    saved_successfully: "Kayıt Başarılı",
    updated_successfully: "Güncelleme Başarılı",
    deleted_successfully: "Silme Başarılı",
    download_email_report: "Raporunuz hazır, indirmek için indir butonuna tıklayınız",
    registration_successful: "Kayıt Başarılı",
    registration_failed: "Kayıt Başarısız",
    pass_reset_time_early: "Yeni bir şifre sıfırlama jetonu istemek için en az 3 dakika beklemelisiniz",
    entity_not_found: "Hesap bulunamadı",
    pass_reset_leng_err: "Şifrenizin uzunluğu en az 6 en fazla 16 karakter uzunluğunda olmalıdır."
  },
  global: {
    comment: "Yorum",
    description: "Açıklama",
    day: "Gün",
    note: "Not",
    employee: "Çalışan",
    address: "Adres",
    explanation: "Açıklama",
    hour: "Saat",
    month: "Ay",
    phone: "Telefon",
    status: "Durum",
    file: "Dosya",
    greeting: "Merhaba, {0}",
    search_for_employee: "Çalışan aramak için birşeyler yazın...",
    others: "Diğerleri",
    importance_enum: {
      LOW: "Düşük",
      MEDIUM: "Orta",
      HIGH: "Yüksek"
    },
    importance: "Önem Derecesi",
    date: "Tarih",
    loading_message: "Yükleniyor...",
    birth_date: "Doğum Günü",
    min_character_message: "En az {0} karakter girmeniz gerekiyor",
    no_employee_message: "Aradığınız kriterde calisan bulunamadi",
    employees: "Çalışanlar",
    beginDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
    beginTime: "Başlangıç Saati",
    endTime: "Bitiş Saati",
    year: "Yıl",
    message: "Mesaj",
    detail: "Detay",
    country: "Ülke",
    active_employees: "Aktif Çalışanlar",
    passive_employees: "İşten Ayrılanlar",
    maxEmployeeCount: "Norm Kadro Sayısı",
    years_old: "yaşında",
    print: "Yazdır",
    expense_management: "Harcama Yönetimi",
    uploaded_files: "Yüklenen Dosyalar",
    loading: "Yükleniyor...",
    employee_selected: "Çalışan seçiniz...|1 çalışan seçildi|{count} çalışan seçildi",
    shift_selected: "Vardiya seçiniz...|1 vardiya seçildi|{count} vardiya seçildi",
    shifts_type: "{0} Vardiyalar",
    total_hours: "Toplam Saat"
  },
  assessment: {
    very_poor: "Çok Kötü",
    poor: "Kötü",
    normal: "Orta",
    good: "İyi",
    very_good: "Çok İyi",
    na: "Değerlendirme Yapılmadı"
  },
  buttons: {
    home: "Anasayfa",
    ok: "Tamam",
    delete: "Sil",
    back: "Geri",
    save: "Kaydet",
    update: "Güncelle",
    edit: "Düzenle",
    cancel: "İptal",
    close: "Kapat",
    dont_save: "Kaydetmeden Çık",
    dont_save_continue: "Kaydetmeden Devam Et",
    save_changes: "Değişiklikleri Kaydet",
    evaluation_finish: "Değerlendirmeyi Tamamla",
    assign: "Atama",
    add: "{0} Ekle",
    add_and_new: "Ekle ve Yeni",
    refresh: "Yenile",
    filter: "Filtrele",
    export: "Dışarı Aktar",
    create: "{0} Oluştur",
    create_and_new: "Oluştur ve Yeni",
    download: "İndir",
    yes: "Evet",
    no: "Hayır",
    clear: "Temizle",
    filter_results: "Sonuçları Filtrele",
    delete_document: "Dokümanı Sil",
    scan: "Tara",
    send_message: "Mesaj Gönder",
    send: "Gönder",
    apply: "Uygula",
    info: "Bilgilendirme",
    prev: "Önceki {0}",
    next: "Sonraki {0}",
    list_table: "Tablo Modu",
    list_card: "Kart Modu",
    continue: "Devam",
    show_all: "Hepsini Göster",
    cancel_leave: "İzİnİ İptal Et",
    select_all: "Tümünü Seç",
    upload: "Yükle",
    file_upload: "Dosya Yükle",
    file_download: "Dosya İşlemleri",
    import: "İçeri Aktar",
    upload_template: "Şablonu Yükle",
    download_template: "Şablonu İndir",
    trigger: "Tetikle",
    action: "İşlem Yap",
    send_registration_credentials: "Kimlik Bilgilerini Gönder",
    on: "Açık",
    off: "Kapalı",
    uploads: {
      employee: "Çalışanları içeri aktar",
      leave: "İzinleri içeri aktar"
    },
    multiple_delete_shift: "Toplu Vardiya Silme",
    multiple_upload_shift: "Toplu Vardiya Yükleme",
    multiple_actions: "Toplu İşlemler",
    send_email_and_sms_notification: "E-mail & SMS bilgilendirmesi Gönder",
    add_expense: "Harcama Talep Et",
    add_imprest: "Avans Talep Et",
    add_overtime: "Fazla Mesai Talep Et",
    add_leave_request: "İzin Talep Et",
    evaluatee: "Değerlendir",
    add_skill: "Soru Ekle",
    sign: "İmzala",
    skip: "Atla",
    back_to_home: "Anasayfaya Dön",
    please_select: "Lütfen seçiniz..."
  },
  response: {
    success: {
      ok: "İşlem başarılı",
      update: "Güncelleme başarılı",
      delete: "Silme başarılı",
      send_sms_password_code: "Şifre yenileme kodu sms olarak gönderildi"
    },
    error: {
      user_not_found: "Kullanıcı adı veya şifre hatalı",
      network_error: "İnternet bağlantı hatası"
    }
  },
  request_status: {
    pending: "Onay Bekleyen",
    PENDING: "Onay Bekleyen",
    approved: "Onaylandı",
    APPROVED: "Onaylandı",
    denied: "Reddedildi",
    DENIED: "Reddedildi",
    cancelled: "İptal Edildi",
    CANCELLED: "İptal Edildi",
    need_extra_detail: "Ekstra detay isteniyor",
    NEED_EXTRA_DETAIL: "Ekstra detay isteniyor",
    undefined: "Bilinmiyor",
    revision: "Revizyon",
    REVISION: "Revizyon"
  },
  shift_types: {
    FIX: "Sabit",
    FLEXIBLE: "Esnek",
    OFF_DAY: "Hafta Tatili",
    OFFDAY: "Hafta Tatili",
    HOLIDAY: "Resmi Tatili",
    WORKDAY: "İş Günü",
    BREAK: "Dinlenme Günü",
    OVERTIME: "Fazla Mesai",
    OVERTIME_SHIFT: "Fazla Mesai Vardiyası",
    ON_LEAVE: "İzinli"
  },
  shift: {
    overtime: "Fazla Mesai",
    missing_time: "Eksik Mesai",
    shift_parameters: "Vardiya Parametresi",
    break: "Mola",
    sub_events: "Ara Kayıtlar",
    included_calculation: "Hesaplamaya dahil edilir",
    not_included_calculation: "Hesaplamaya dahil edilmez",
    included_overtime_calculation: "Fazla mesai hesaplamaya dahil edilmez",
    not_included_overtime_calculation: "Fazla mesai hesaplamaya dahil edilir",
    included_missing_time_calculation: "Eksik mesai hesaplamaya dahil edilmez",
    not_included_missing_time_calculation: "Eksik mesai hesaplamaya dahil edilir",
    work_day: "Çalışma Günü",
    overtime_day: "Fazla Mesai Günü",
    full_time: "Tam Mesai",
    absent: "Devamsız",
    unpaid_leave: "Ücretsiz İzin",
    paid_leave: "Ücretli İzin",
    public_holiday: "Resmi Tatil",
    on_leave: "İzinli",
    off_day: "Hafta Tatili",
    break_day: "Dinlenme Günü",
    incalculable: "Hesaplanamayan Mesai"
  },
  sensors: {
    NFC: "Nfc",
    FACE: "Yüz Tanıma",
    RFID: "Rfid",
    FINGER: "Parmak izi",
    BLUETOOTH: "Bluetooth",
    GATEWARE: "Gateware",
    BEACON: "Beacon",
    GPS: "Gps",
    WIFI: "Wifi",
    ID: "Id",
    QR: "Qr",
    QR_CODE: "Kare Kod",
    PASSWORD: "Şifre",
    PIN: "Pin",
    CARD: "Kart",
    FIXED: "Sabit",
    EXTERNAL: "Harici",
    JAN: "JAN",
    WEB: "Web"
  },
  identity_type: {
    FACE: "Yüz",
    PASSWORD: "Şifre",
    PIN: "Pin",
    FINGER: "Parmak İzi",
    QR_CODE: "Kare Kod",
    CARD: "Kart",
    EXTERNAL: "Harici"
  },
  event_types: {
    BREAK_IN: "Mola Giriş",
    BREAK_OUT: "Mola Çıkış",
    LUNCH_IN: "Yemek Giriş",
    LUNCH_OUT: "Yemek Çıkış",
    DUTY_IN: "Görev Giriş",
    DUTY_OUT: "Görev Çıkış",
    CLOCK_IN: "Mesai Giriş",
    CLOCK_OUT: "Mesai Çıkış",
    HOME_CLOCK_IN: "Evden Mesai Giriş",
    HOME_CLOCK_OUT: "Evden Mesai Çıkış",
    TRAINING_IN: "Eğitim Giriş",
    TRAINING_OUT: "Eğitim Çıkış",
    UNKNOWN: "Bilinmiyor",
    undefined: "Bilinmiyor"
  },
  currency: {
    amount: "Tutar",
    requested_amount: "Talep edilen tutar",
    approved_amount: "Onaylanan tutar",
    code: "Birim",
    codes: {
      TRY: "TL",
      USD: "DOLAR",
      EUR: "EURO"
    }
  },
  titles: {
    expense: {
      create: "Harcama Ekle",
      detail: "Harcama Detayı"
    },
    imprest: {
      create: "Avans Ekle",
      detail: "Avans Detayı"
    }
  },
  language: {
    tr: "Türkçe",
    en: "İngilizce",
    de: "Almanca",
    TURKISH: "Türkçe",
    ENGLISH: "İngilizce",
    GERMAN: "Almanca"
  },
  status: {
    active: "Aktif",
    passive: "Pasif",
    enable: "Etkin",
    disable: "Devre Dışı"
  },
  gender: {
    male: "Erkek",
    female: "Kadın",
    other: "Belirtilmemiş",
    others: "Belirtilmemiş",
    MALE: "Erkek",
    FEMALE: "Kadın",
    OTHER: "Belirtilmemiş"
  },
  marital_status: {
    married: "Evli",
    single: "Bekar",
    divorced: "Boşanmış"
  },
  education: {
    student: "Öğrenci",
    primary_school: "İlk Okul",
    secondary_school: "Orta Okul",
    high_school: "Lise",
    collage: "Ön Lisans",
    university: "Lisans",
    master: "Yüksek Lisans",
    phd: "Doktora"
  },
  education_languages: {
    turkish: "Türkçe",
    english: "İngilizce",
    german: "Almanca",
    french: "Fransızca",
    dutch: "Hollandaca / Flemenkçe",
    spanish: "İspanyolca",
    italian: "İtalyanca",
    arabic: "Arapça",
    russian: "Rusça",
    persian: "Farsça",
    chinese: "Çince",
    japanese: "Japonca",
    hindi: "Hintçe",
    latin: "Latince",
    portuguese: "Portekizce",
    korean: "Korece"
  },
  military_service: {
    done: "Tamamladı",
    undone: "Yapılmadı",
    exempt: "Muaf",
    suspended: "Askıya Alındı"
  },
  academic_title: {
    lecturer: "Eğitmen",
    research_assistant: "Araştırma Görevlisi",
    assistant_professor: "Asistan Profesör",
    associate_professor: "Doçent",
    professor: "Profesör"
  },
  employment_type: {
    full_time: "Tam Zamanlı",
    part_time: "Yarı Zamanlı",
    casual: "Gündelik",
    contracted: "Sözleşmeli",
    freelance: "Serbest",
    intern: "Stajyer",
    mobile: "Mobil",
    retired: "Emekli",
    trial: "Deneme Süresi",
    seasonal: "Sezonluk",
    disabled: "Engelli"
  },
  collar_type: {
    white: "Beyaz",
    blue: "Mavi",
    gray: "Gri"
  },
  quite_job_reasons: {
    resignation: "İstifa",
    cancellation_of_labor_contract: "Sözleşme İptali",
    military_service: "Askerlik",
    other: "Diğer"
  },
  blood_type: {
    o_rh_negative: "0-",
    o_rh_positive: "0+",
    a_rh_negative: "A-",
    a_rh_positive: "A+",
    b_rh_negative: "B-",
    b_rh_positive: "B+",
    ab_rh_negative: "AB-",
    ab_rh_positive: "AB+"
  },
  time_duration: {
    hour: "Saat",
    minute: "Dakika",
    second: "Saniye"
  },
  date: {
    year: "Yıl",
    month: "Ay",
    day: "Gün",
    time: "Saat",
    week: "Hafta",
    minute: "Dakika"
  },
  validations: {
    messages: {
      phone: "{_field_} alanının geçerli bir telefon numarası olması gerekir",
      password_match: "Şifreler uyuşmuyor",
      password_math: "Şifreler uyuşmuyor",
      integer: "{_field_} alanı bir tamsayı olmalıdır",
      date: "Geçerli bir tarih formatı giriniz (yyyy-mm-dd)"
    }
  },
  nationalities: {
    Afghan: "Afgan",
    Albanian: "Arnavut",
    Algerian: "Cezayirli",
    American: "Amerikalı",
    Andorran: "Andorralı",
    Angolan: "Angolalı",
    Antiguans: "Antigua ve Berbudalı",
    Argentinean: "Arjantinli",
    Armenian: "Ermeni",
    Australian: "Avustralyalı",
    Austrian: "Avusturyalı",
    Azerbaijani: "Azerbaycanlı",
    Bahamian: "Bahamalı",
    Bahraini: "Bahreynli",
    Bangladeshi: "Bangladeşli",
    Barbadian: "Barbadoslu",
    Barbudans: "Barbudalı",
    Botswana: "Botsvanalı",
    Belarusian: "Belaruslu",
    Belgian: "Belçikalı",
    Belizean: "Belizeli",
    Beninese: "Beninli",
    Bhutanese: "Butanlı",
    Bolivian: "Bolivyalı",
    Bosnian: "Bosnalı",
    Brazilian: "Brezilyalı",
    British: "İngiliz",
    Bruneian: "Brunei Darüsselamlı",
    Bulgarian: "Bulgar",
    Burkinabe: "Burkina Fasolu",
    Burmese: "Myanmarlı",
    Burundian: "Burundili",
    Cambodian: "Kamboçyalı",
    Cameroonian: "Kamerunlu",
    Canadian: "Kanadalı",
    "Cape Verdean": "Yeşil Burunlu",
    "Central African": "Orta Afrikalı",
    Chadian: "Çadlı",
    Chilean: "Şilili",
    Chinese: "Çinli",
    Colombian: "Kolombiyalı",
    Comoran: "Komorlu",
    Congolese: "Kongolu",
    "Costa Rican": "Kosta Rikalı",
    Croatian: "Hırvat",
    Cuban: "Kübalı",
    Cypriot: "Kıbrıslı",
    Czech: "Çek",
    Danish: "Danimarkalı",
    Djibouti: "Cibutili",
    Dominican: "Dominikli",
    Dutch: "Hollandalı",
    "East Timorese": "Doğu Timorlu",
    Ecuadorean: "Ekvadorlu",
    Egyptian: "Mısırlı",
    Emirian: "Emiranlı",
    "Equatorial Guinean": "Ekvator Gineli",
    Eritrean: "Eritreli",
    Estonian: "Eston",
    Ethiopian: "Etiyopyalı",
    Fijian: "Fijili",
    Filipino: "Filipinli",
    Finnish: "Fin",
    French: "Fransız",
    Gabonese: "Gabonlu",
    Gambian: "Gambiyalı",
    Georgian: "Gürcü",
    German: "Alman",
    Ghanaian: "Ganalı",
    Greek: "Yunan",
    Grenadian: "Grenadalı",
    Guatemalan: "Guatemalalı",
    "Guinea-Bissauan": "Gine-Bissaulu",
    Guinean: "Gineli",
    Guyanese: "Guyanalı",
    Haitian: "Haitili",
    Herzegovinian: "Hersekli",
    Honduran: "Honduraslı",
    Hungarian: "Macar",
    "I-Kiribati": "Kiribatili",
    Icelander: "İzlandalı",
    Indian: "Hintli",
    Indonesian: "Endonezyalı",
    Iranian: "İranlı",
    Iraqi: "Iraklı",
    Irish: "İrlandalı",
    Israeli: "İsrailli",
    Italian: "İtalyan",
    Ivorian: "Fildişili",
    Jamaican: "Jamaikalı",
    Japanese: "Japon",
    Jordanian: "Ürdünlü",
    Kazakhstani: "Kazak",
    Kenyan: "Kenyalı",
    "Kittian and Nevisian": "Saint Kitts ve Nevisli",
    Kuwaiti: "Kuveytli",
    Kyrgyz: "Kırgız",
    Laotian: "Laoslu",
    Latvian: "Leton",
    Lebanese: "Lübnanlı",
    Liberian: "Liberyalı",
    Libyan: "Libyalı",
    Liechtensteiner: "Lihtenştaynlı",
    Lithuanian: "Litvanyalı",
    Luxembourger: "Lüksemburglu",
    Macedonian: "Makedonyalı",
    Malagasy: "Madagaskarlı",
    Malawian: "Malavili",
    Malaysian: "Malezyalı",
    Maldivan: "Maldivlerli",
    Malian: "Malili",
    Maltese: "Maltalı",
    Marshallese: "Marşallı",
    Mauritanian: "Moritanyalı",
    Mauritian: "Mauritiuslu",
    Mexican: "Meksikalı",
    Micronesian: "Mikronezyalı",
    Moldovan: "Moldovalı",
    Monacan: "Monakolu",
    Mongolian: "Moğol",
    Moroccan: "Faslı",
    Mosotho: "Lesotolu",
    Motswana: "Botsvanalı",
    Mozambican: "Mozambikli",
    Namibian: "Namibyalı",
    Nauruan: "Naurulu",
    Nepalese: "Nepalli",
    "New Zealander": "Yeni Zelandalı",
    Nicaraguan: "Nikaragualı",
    Nigerian: "Nijeryalı",
    Nigerien: "Nijer",
    "North Korean": "Kuzey Koreli",
    "Northern Irish": "İrlandalı",
    Norwegian: "Norveçli",
    Omani: "Ummanlı",
    Pakistani: "Pakistanlı",
    Palauan: "Palaulu",
    Panamanian: "Panamalı",
    "Papua New Guinean": "Papua Yeni Gineli",
    Paraguayan: "Paraguaylı",
    Peruvian: "Perulu",
    Polish: "Polonyalı",
    Portuguese: "Portekizli",
    Qatari: "Katarlı",
    Romanian: "Romen",
    Russian: "Rus",
    Rwandan: "Ruandalo",
    "Saint Lucian": "Saint Lucialı",
    Salvadoran: "El Salvadorlu",
    Samoan: "Samoalı",
    "San Marinese": "San Marinolu",
    "Sao Tomean": "Sao Tomeli",
    Saudi: "Suudi",
    Scottish: "İskoç",
    Senegalese: "Senegalli",
    Serbian: "Sırp",
    Seychellois: "Seyşellerli",
    "Sierra Leonean": "Sierra Leoneli",
    Singaporean: "Singapurlu",
    Slovakian: "Slovak",
    Slovenian: "Slovenyalı",
    "Solomon Islander": "Solomon Adalı",
    Somali: "Somalili",
    "South African": "Güney Afrikalı",
    "South Korean": "Güney Koreli",
    Spanish: "İspanyol",
    "Sri Lankan": "Sri Lankalı",
    Sudanese: "Sudanlı",
    Surinamer: "Surinamlı",
    Swazi: "Esvati̇ni̇li",
    Swedish: "İsveçli",
    Swiss: "İsviçreli",
    Syrian: "Suriyeli",
    Taiwanese: "Tayvanlı",
    Tajik: "Tacik",
    Tanzanian: "Tanzanyalı",
    Thai: "Taylandlı",
    Togolese: "Togolu",
    Tongan: "Tongalı",
    "Trinidadian or Tobagonian": "Trinidad ve Tobagolu",
    Tunisian: "Tunuslu",
    Turkish: "Türk",
    Tuvaluan: "Tuvalulu",
    Ugandan: "Ugandalı",
    Ukrainian: "Ukraynalı",
    Uruguayan: "Uruguaylı",
    Uzbekistani: "Özbek",
    Venezuelan: "Venezuelalı",
    Vietnamese: "Vietnamlı",
    Welsh: "Galler",
    Yemenite: "Yemenli",
    Zambian: "Zambiyalı",
    Zimbabwean: "Zimbabveli"
  },
  disability_level: {
    first_level: "1. Seviye",
    second_level: "2. Seviye",
    third_level: "3. Seviye"
  },
  social_security_type: {
    SS_4A: "SSK",
    SS_4B: "Bağkur",
    SS_4C: "Emekli Sandığı"
  },
  days: {
    monday: "Pazartesi",
    tuesday: "Salı",
    wednesday: "Çarşamba",
    thursday: "Perşembe",
    friday: "Cuma",
    saturday: "Cumartesi",
    sunday: "Pazar"
  },
  api_error: {
    "401": "E-mail ya da şifreniz hatalı",
    "403": "Rolünüzün Giriş Yetkisi Yoktur",
    "700": "Geçersiz İstek",
    "701": "Eksik Parametre",
    "702": "Desteklenmeyen Dosya Formatı",
    "703": "Veri doğrulaması yapılamadı",
    "704": "Limit hatası",
    "705": "Eksik ya da hatalı istekte bulundunuz",
    "706": "Hatalı veri kayıt edilemedi",
    "707": "Aynı veri sistemde mevcut",
    "708": "Geçersiz istek methodu",
    "711": "Veri Bulunamadı",
    "712": "Obje alanı bulunamadı",
    "713": "Dosya boyutu limiti",
    "714": "Geçersiz dosya formatı isteği",
    "715": "Geçersiz oturum isteği",
    "716": "Hatalı veri tipi",
    "717": "Hatalı Excel Formatı",
    "718": "Yeni bir şifre sıfırlamak için en az 3 dakika beklemelisiniz",
    "719": "Şifre sıfırlama kodunun süresi doldu",
    "720": "Suprema sdk hatası",
    "750": "Oturum yenileme anahtarı bulunamadı",
    "751": "Aynı veri sistemde mevcut",
    "752": "Yetkisiz kayıt denemesi",
    "753": "Bu veri başka yerlerde kullanıyor",
    "754": "E-mail gönderilemedi",
    "755": "Kota limiti aşıldı",
    "756": "Talep ettiğiniz tarihler arasında izin bulunmaktadır",
    "757": "Yeni kod talep edebilmeniz için en az 3 dakika beklemelisiniz",
    "758": "Sms kodunun süresi bitmiş",
    "759": "Sms kodu doğrulanamadı",
    "760": "Yetkinlik maddeleri girilmedi",
    "762": "Aktif değerlendirme döneminde değilsiniz"
  }
};
